import React from 'react'
import { camelCase, kebabCase } from 'lodash'

import {
  IProps as IIconGrid,
  IconGrid,
} from 'marketing-site/src/mvp-v2/library/components/IconGrid'
import {
  CONTENT_TYPE,
  IIconGrid as IContentfulIconGrid,
} from 'marketing-site/@types/generated/contentful'
import { renderTransformedComponent } from 'marketing-site/lib/transformedComponents'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'

export const ContentfulIconGrid = (iconGrid: IContentfulIconGrid): React.ReactElement => (
  <EntryMarker entry={iconGrid}>{() => <IconGrid {...transformIconGrid(iconGrid)} />}</EntryMarker>
)

const transformItems = (items: IContentfulIconGrid['fields']['items']) => {
  const filteredItems = items.map((item) => {
    const contentTypeId = item.sys.contentType?.sys.id as CONTENT_TYPE
    return renderTransformedComponent(contentTypeId, item)
  })
  return filteredItems
}

export const transformCTA = (media: IContentfulIconGrid['fields']['cta']) => {
  if (!media) return
  const contentTypeId = media?.sys.contentType?.sys.id as CONTENT_TYPE
  return renderTransformedComponent(contentTypeId, media)
}

export function transformIconGrid({ fields }: IContentfulIconGrid): IIconGrid {
  return {
    ...fields,
    cta: fields.cta && transformCTA(fields.cta),
    items: transformItems(fields.items),
    theme: fields.theme && (kebabCase(fields.theme) as IIconGrid['theme']),
    backgroundColor:
      fields.backgroundColor && (camelCase(fields.backgroundColor) as IIconGrid['backgroundColor']),
  }
}
